import {
  addHours,
  differenceInHours,
  differenceInMinutes,
  format,
  parse,
  parseISO,
} from 'date-fns';
import { pt } from 'date-fns/locale';

export const timeAgo = (date) => {
  const givenDate = new Date(date);
  const now = new Date();
  const diff = now - givenDate;

  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (minutes < 60) {
    return `${minutes} minutos atrás`;
  } else if (hours < 24) {
    return `${hours} horas atrás`;
  } else {
    return `${days} dias atrás`;
  }
};

export function timeDifference(dateTimeStr, hours) {
  // Parse the input date-time string into a Date object using the custom format
  if (!dateTimeStr) {
    return null;
  }

  const dateTime = parse(dateTimeStr, 'dd/MM/yyyy HH:mm:ss', new Date());

  // Get the current time
  const now = new Date();

  // Add the specified hours to the input date-time
  const target = addHours(dateTime, hours);

  // Calculate the difference in minutes and hours between the target time and now
  const diffMinutes = differenceInMinutes(target, now);
  const hoursDiff = differenceInHours(target, now);
  const minutesDiff = diffMinutes % 60;

  // Generate the output string based on the calculated differences
  if (hoursDiff === 0) {
    return `${minutesDiff} minutos`;
  } else if (hoursDiff === 1 && minutesDiff === 0) {
    return '1 hora';
  } else if (hoursDiff === 1 && minutesDiff > 0) {
    return `1 hora e ${minutesDiff} minutos`;
  } else if (hoursDiff > 1 && minutesDiff === 0) {
    return `${hoursDiff} horas`;
  } else {
    return `${hoursDiff} horas e ${minutesDiff} minutos`;
  }
}

export const dateInWords = (date) => {
  const dateObject = parseISO(date);
  const dayFormat = 'cccc';
  const monthFormat = 'MMMM';

  const dayOfWeek = format(dateObject, dayFormat, { locale: pt });
  const day = format(dateObject, 'd', { locale: pt });
  const month = format(dateObject, monthFormat, { locale: pt });

  const formattedDate = `${day} de ${month}, ${dayOfWeek}`;

  return formattedDate;
};

export const now = () => format(new Date(), 'dd/MM/yyyy HH:mm:ss');
